"use client"
import { motion } from "motion/react"

export const FadeInFromBottom = ({ children }: { children: React.ReactNode }) => {
  return (
    <motion.div
      className="flex w-full justify-center"
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1 }}>
      {children}
    </motion.div>
  )
}
